<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.purchase_entry">
    <div class="banner freeze_height" *ngIf="purchaseEntryDetails">
        <div class="row">
            <div class="col-md-3">
                <a class="button" [routerLink]="['/purchase-entries' + localService.basicParamsString,businessId]">
                    <i class="material-icons button icon_adjust">arrow_back</i>
                </a>
                &nbsp;
                <app-label [Text]="localService.languageContent.purchase_entry.title" />
                <span class="en">
                    {{purchaseEntryDetails.purchaseEntry.v3 ?? purchaseEntryDetails.purchaseEntry.v7}}
                </span>
            </div>
            <div class="col-md-4">
                <app-label [Text]="localService.languageContent.purchase_entry.supplier_name" />
                <span [ngClass]="localService.getLanguageCode(purchaseEntryDetails.purchaseEntry.v10)">
                    {{purchaseEntryDetails.purchaseEntry.v9 ?? '-'}}
                </span>
            </div>
            <div class="col-md-5">
                <div class="row">
                    <div class="col-7">
                        <app-label [Text]="localService.languageContent.table.created_on" />
                        <span class="en">
                            {{purchaseEntryDetails.purchaseEntry.v8 | localDate}}
                        </span>
                    </div>
                    <div class="col-5" style="text-align: right;">
                        <label style="font-weight: normal; margin-left: 30px;">
                            <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                            <span
                                class="normal_color">{{localService.languageContent.purchase_entry.show_inactive}}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="data">
            <div [ngClass]="hasValidBatchDetails ? 'col-md-3' : 'col-md-4'">
                <div class="search_dd">
                    <ngx-select id="{{elementIds.product_dd}}"
                        placeholder="{{localService.languageContent.purchase_entry.select_product}}"
                        title="{{localService.languageContent.purchase_entry.select_product}}"
                        (typed)="onSearch($event)" [items]="searchItems" [optionValueField]="'key'"
                        [optionTextField]="'v3'" [allowClear]="true" (focus)="onFocusProducts()"
                        (select)="localService.onFocusNextInput(hasValidBatchDetails ? elementIds.batch_number : elementIds.bar_code, 1)"
                        [(ngModel)]="data.v1" (remove)="onRemoveProduct()">
                        <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                            <div class="row" title="{{option.data.v1}}">
                                <div class="col-12">
                                    <div>
                                        <span class="en">{{option.data.v5}}&nbsp;-&nbsp;</span>
                                        <span
                                            [ngClass]="localService.getLanguageCode(option.data.v2)">{{option.data.v1}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-select>
                </div>
                <div class="search_scan">
                    <app-spinner *ngIf="isShowSpinnerCount > 0"
                        style="position: absolute; margin-top: -20px;"></app-spinner>
                    <app-qr-scanner *ngIf="isShowSpinnerCount == 0" style="position: absolute; margin-top: -24px;"
                        (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
                </div>
            </div>
            <div [ngClass]="hasValidBatchDetails ? 'col-md-3' : 'col-md-2'" style="margin-top: 10px;">
                <div class="row">
                    <div *ngIf="hasValidBatchDetails" class="col-6">
                        <input autocomplete="off" type="text" id="{{elementIds.batch_number}}" class="en"
                            [(ngModel)]="data.v13"
                            placeholder="{{localService.languageContent.purchase_entry.batch_id}}"
                            title="{{localService.languageContent.purchase_entry.batch_id}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.bar_code, 1)" />
                    </div>
                    <div [ngClass]="hasValidBatchDetails ? 'col-6' : 'col-12'">
                        <input autocomplete="off" type="text" id="{{elementIds.bar_code}}" class="en"
                            [(ngModel)]="data.v4" placeholder="{{localService.languageContent.purchase_entry.bar_code}}"
                            title="{{localService.languageContent.purchase_entry.bar_code}}" [disabled]="!data.v1"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.qty, 1)" />
                    </div>
                </div>
            </div>
            <div [ngClass]="hasValidBatchDetails ? 'col-md-5' : 'col-md-6'" style="margin-top: 10px;">
                <div class="row">
                    <div [ngClass]="hasValidBatchDetails ? 'col-2' : 'col-3'">
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.qty}}"
                            [(ngModel)]="data.v2" style="width:100%"
                            placeholder="*{{localService.languageContent.purchase_entry.qty}}"
                            title="{{localService.languageContent.purchase_entry.qty}}"
                            (keydown.enter)="localService.onFocusNextInput(elementIds.price, 1)" [disabled]="!data.v1"
                            [ngClass]="data.v2 ? 'en' : ''" />
                    </div>
                    <div [ngClass]="hasValidBatchDetails ? 'col-4' : 'col-5'">
                        <div class="row">
                            <div class="col-7">
                                <ngx-select id="{{elementIds.price_options_dd}}"
                                    placeholder="{{localService.languageContent.purchase_entry.price}}"
                                    title="{{localService.languageContent.purchase_entry.price}}" [items]="priceOptions"
                                    [optionValueField]="'key'" [optionTextField]="'value'" [noAutoComplete]="true"
                                    [allowClear]="false" (select)="onAction(3)" [disabled]="!data.v1"
                                    [(ngModel)]="selectedPriceOption">
                                    <ng-template ngx-select-option-selected ngx-select-option let-option
                                        let-text="text">
                                        <div class="row">
                                            <div class="col-12">
                                                <div>
                                                    <span>{{localService.languageContent.purchase_entry[option.data.value]}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </ngx-select>
                            </div>
                            <div class="col-5">
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.price}}" [(ngModel)]="data.v3" style="width:100%"
                                    placeholder="{{localService.languageContent.purchase_entry.price}}"
                                    title="{{localService.languageContent.purchase_entry.price}}"
                                    (keydown.enter)="localService.onFocusNextInput(elementIds.add, 5,true)"
                                    [disabled]="!data.v1" [ngClass]="data.v3 ? 'en' : ''" />
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="hasValidBatchDetails ? 'col-3' : 'col-4'">
                        <button class="btn btn-primary" style="width:100%;" (click)="onSavePurchaseEntryDetail()"
                            [disabled]="!data.v1"
                            id="{{elementIds.add}}">{{localService.languageContent.common.add}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="custom_rows_body banner" *ngIf="(source && source.items.length > 0)"
        [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" style="margin-top: 5px;">
        <div class="row styled_row" *ngFor="let item of source.items">
            <div class="col-md-4">
                <button class="button_icon icon_adjust"
                    title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                    (click)="onActiveInactiveStatus(item.key)"
                    [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                    "toggle_on" : "toggle_off"}}</button>
                <a class="button"
                    [routerLink]="['/serial-numbers' + localService.basicParamsString, businessId, item.v1,item.key]">
                    <i class="material-icons button icon_adjust"
                        [ngStyle]="{'color' : item.v6 == '1' ? 'green' : ''}">numbers</i>
                </a>
                <span class="en">
                    {{item.v5}}&nbsp;-&nbsp;
                </span>
                <span [ngClass]="localService.getLanguageCode(item.v10)">
                    {{item.v9}}
                </span>
                <span class="en" style="font-style: italic;"
                    *ngIf="item.v13 && item.v13.length > 0">&nbsp;({{item.v13}})</span>
            </div>
            <div class="col-md-2">
                <span class="en">{{item.v14}}</span>
            </div>
            <div class="col-md-2" *ngIf="purchaseEntryDetails.isMaintainStatus">
                <div *ngIf="item.v17 != '1'">
                    <button class="button_icon button_icon_color icon_adjust" [disabled]="item.v16 == '0'"
                        (click)="onAction(4,item.key)">info</button>
                    &nbsp;
                    <span>{{item.v15}}</span>
                </div>
                <div style="margin: 5px;" *ngIf="item.v17 == '1'">
                    <button class="button_icon button_icon_color icon_adjust" [disabled]="item.v16 == '0'"
                        (click)="onAction(4,item.key)">info</button>
                    &nbsp;
                    <div [style]="dropdownStyle ?? 'width: calc(100% - 100px); display: inline-block;'"
                        [id]="elementIds.status_div+item.key">
                        <ngx-select [(ngModel)]="item.v15" [optionValueField]="'key'" [optionTextField]="'value'"
                            [items]="purchaseEntryDetails.purchaseEntryStatuses" [noAutoComplete]="true"
                            [id]="elementIds.status+item.key">
                        </ngx-select>
                    </div>
                    &nbsp;
                    <button [ngStyle]="{'left' : dropdownWidth + 'px', 'position' : 'relative !important'}"
                        class="button_icon button_icon_color icon_adjust" [disabled]="item.v15 == item.v17"
                        (click)="onAction(5,item.key)">save</button>
                </div>
            </div>
            <div [ngClass]="purchaseEntryDetails.isMaintainStatus ? 'col-md-4' : 'col-md-6'">
                <div class="row">
                    <div class="col-4 right">
                        <input autocomplete="off" type="number" class="number"
                            [readOnly]="purchaseEntryDetails.isMaintainStatus && item.v17 != '1'"
                            (keypress)="localService.isNumberOnly($event,numericConfig)"
                            id="{{elementIds.qty}}-{{item.v5}}" [(ngModel)]="item.v2" style="width:100%"
                            placeholder="*{{localService.languageContent.purchase_entry.qty}}"
                            title="{{localService.languageContent.purchase_entry.qty}}" (blur)="onAction(1, item.key)"
                            (keydown.enter)="onAction(1, item.key)" [ngClass]="item.v2 ? 'en' : ''" />
                    </div>
                    <div class="col-4 right">
                        <input autocomplete="off" type="number" class="number"
                            [readOnly]="purchaseEntryDetails.isMaintainStatus && item.v17 != '1'"
                            (keypress)="localService.isNumberOnly($event,numericConfig)"
                            id="{{elementIds.price}}-{{item.v5}}" [(ngModel)]="item.v3" style="width:100%"
                            placeholder="{{localService.languageContent.purchase_entry.price}}"
                            title="{{localService.languageContent.purchase_entry.price}}" (blur)="onAction(2, item.key)"
                            (keydown.enter)="onAction(2, item.key)" [ngClass]="item.v3 ? 'en' : ''" />
                    </div>
                    <div class="col-4 right">
                        <span class="en">
                            {{item.v7}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="source && source.paging" [paging]="source.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>